import React, { FC, useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  ModalScrollableContainer,
  ModalScrollableHeader,
  ModalScrollableContent,
} from '../../../components/modal';
import { Hyperlink } from '../../../components/Hyperlink';
import styles from './commentary_legislation_sources_modal.module.scss';
import {
  CommentarySourceType,
  CommentaryLegislationSource,
} from '../../commentary.types';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { getCommentaryLegislationArticlesById } from '../../commentary.api';
import { Chip } from '../../../components/chips/Chip';

type Props = {
  commentaryId: string;
  isOpen: boolean;
  onRequestClose: () => void;
  source: string;
};

export const CommentaryLegislationSourcesModal: FC<Props> = ({
  commentaryId,
  isOpen,
  onRequestClose,
  source,
}) => {
  const [commentarySources, setCommentarySources] = useState<
    Array<CommentaryLegislationSource>
  >([]);

  useEffect(() => {
    async function fetchCommentarySources() {
      try {
        const { data } = await getCommentaryLegislationArticlesById(
          commentaryId,
        );
        setCommentarySources(data);
      } catch (error) {
        throw error;
      }
    }
    fetchCommentarySources();
  }, [commentaryId]);

  const onSourceClicked = (
    commentarySource: CommentaryLegislationSource,
    index: number,
  ) => () => {
    doctrineAnalytics('Search ModalCommentarySourcesOpened', {
      commentaryId,
      sourceId: commentarySource.docId,
      source,
      position: index,
      type: CommentarySourceType.LEGISLATION,
    });
  };

  return (
    <ModalScrollableContainer isOpen={isOpen} onRequestClose={onRequestClose}>
      <ModalScrollableHeader
        onClose={onRequestClose}
        title={
          <FormattedMessage
            id="commentary/CommentaryLegislationSourcesModal.tsx/1"
            values={{ count: commentarySources.length }}
          />
        }
      />
      <ModalScrollableContent>
        <ul className={styles.content}>
          {commentarySources.map((commentarySource, index) => (
            <li
              key={`commentary-source-${commentarySource.docId}`}
              className={styles.row}
            >
              <Hyperlink
                href={commentarySource.url}
                target="_blank"
                source={source}
                onClick={onSourceClicked(commentarySource, index)}
                className={styles.link}
              >
                {commentarySource.title}
              </Hyperlink>
              <Chip color="secondary" className={styles.chip}>
                <FormattedMessage
                  id="commentary/CommentaryLegislationSourcesModal.tsx/2"
                  values={{ count: commentarySource.occurrenceCount }}
                />
              </Chip>
            </li>
          ))}
        </ul>
      </ModalScrollableContent>
    </ModalScrollableContainer>
  );
};
